import * as type from "../action-types";

type load = any;

export const getMe = () => ({
    type: type.ME
});

export const searchUsersAction = (payload?: load, isNotPpeddUser?: boolean, projectId?: string) => ({
    type: type.SEARCH_USERS,
    payload,
    isNotPpeddUser,
    projectId
});

